import OrganizationSearch from '../../organization/organization-search/OrganizationSearch';
import { ContentTitle, Title } from '../typography/Heading';
import { isValidOrganizationNumber } from '../../organization/organization-model';
import {
    fetchActiveTemplateCausesForOrganization,
    getOrganizationByOrganizationNumber,
} from '../../organization/organization-actions';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import CreateProjectButton from '../create-project-button/CreateProjectButton';
import CheckedPanel from '../panel/CheckedPanel';
import styles from './find-organization.module.less';

const FindOrganization = ({
    templateId,
    title = 'Hvilken organisasjon ønsker du å gi til?',
    buttonText = 'Lag en bursdagsinnsamling',
    redirectToPreview = true,
    onlyCharities = true,
    backgroundColor = '#FFF',
    causeType = 'BIRTHDAY',
}) => {
    const dispatch = useDispatch();
    const [organization, setOrganization] = useState();
    const [causeTypeTemplateId, setCauseTypeTemplateId] = useState();

    const handleOrganizationSelection = async (selectedOption) => {
        const { value, label } = selectedOption;
        if (isValidOrganizationNumber(value)) {
            const organization = await dispatch(getOrganizationByOrganizationNumber(value));

            const templateCauses = await dispatch(
                fetchActiveTemplateCausesForOrganization({ organizationId: organization.id })
            );
            setCauseTypeTemplateId(templateCauses.find((cause) => cause.type === causeType)?.template_id);

            setOrganization({
                id: organization.id,
                name: label,
                imgUrl: organization.img_url,
                organizationNumber: organization.organization_number,
            });
        }
    };

    return (
        <div className={styles.wrapper} style={{ backgroundColor }}>
            <div className={styles.container}>
                <ContentTitle className={styles.title}>{title}</ContentTitle>
                {organization?.id ? (
                    <>
                        <div onClick={() => setOrganization(null)} className={styles.chosenOrganization}>
                            <CheckedPanel active>
                                <Title tag="h2" className={styles.orgTitle}>
                                    {organization?.name}
                                </Title>
                            </CheckedPanel>
                        </div>

                        <div className={styles.createProjectButtonWrapper}>
                            <CreateProjectButton
                                linkParams={`?templateId=${causeTypeTemplateId || templateId}&organizationId=${
                                    organization.id
                                }&redirectToPreview=${redirectToPreview}`}
                            >
                                {buttonText}
                            </CreateProjectButton>
                        </div>
                    </>
                ) : (
                    <OrganizationSearch
                        fieldName="organization_number"
                        handleOrganizationSelection={handleOrganizationSelection}
                        hidePromotedOrganizations={true}
                        onlyCharities={onlyCharities}
                    />
                )}
            </div>
        </div>
    );
};

export default FindOrganization;
